import { Spacer, SpacerProps } from '@chakra-ui/react';
import type { FC } from 'react';
export type QSpacerProps = SpacerProps;

export const QSpacer: FC<QSpacerProps> = (props) => {
  return <Spacer {...props} />;
};
